<template>
  <transition @enter="onOpenMenu" @leave="onCloseMenu" @beforeLeave="beforeLeave">
    <div class="page-menu-container" v-if="menuSwitch" ref="wrapper">
      <page-header v-if="$bowser.mobile && false"></page-header>
      <div class="main__body">
        <div class="left-content-container">
          <p v-if="!$bowser.mobile">
            COPYRIGHT WJID Interior Architecture Design 维几设计 版权所有 |
            <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">沪ICP备19026272号-1</a>
          </p>
        </div>
        <div class="menu-nav-container">
          <ul class="nav-list">
            <li v-for="(item, index) in menus" :key="index" class="list__item">
              <template v-if="item.link">
                <router-link
                  tag="a"
                  class="item__link"
                  :to="{
                    path: item.link
                  }"
                >
                  {{ item.name }}
                </router-link>
              </template>
              <template v-else>
                <a href="" class="item__link">{{ item.name }}</a>
              </template>
            </li>
          </ul>
        </div>
        <div class="bg"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import pageHeader from './header.vue';

export default {
  name: 'c__menu',
  components: {
    pageHeader,
  },
  data() {
    return {
      menus: [
        {
          name: 'about',
          link: '/about',
        },
        {
          name: 'project',
          link: '/products',
        },
        {
          name: 'awards',
          link: '/awards',
        },
        {
          name: 'news',
          link: '/news',
        },
        {
          name: 'jobs',
          link: '/join',
        },
        {
          name: 'contact',
          link: '/contact',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      menuSwitch: 'd1MenuSwitch',
    }),
  },
  mounted() {},
  methods: {
    onOpenMenu(e, done) {
      done();
      setTimeout(() => {
        e.querySelector('.main__body').classList.add('--actived');
      }, 0);
    },
    beforeLeave(e) {
      e.querySelector('.main__body').classList.add('before-close');
    },
    onCloseMenu(e, done) {
      e.querySelector('.main__body').classList.remove('--actived');
      const p = new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, 1200);
      });
      p.then(() => {
        done();
      });
    },
  },
};
</script>

<style></style>
